(function () {
  'use strict';

  var configElement = document.getElementById('HansoSpotifyPixelConfig');

  if (!configElement || window.__hansoSpotifyTrackingLoaded) {
    return;
  }

  window.__hansoSpotifyTrackingLoaded = true;

  var config;

  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  if (!config || !config.pixelKey) {
    return;
  }

  var pendingFormKey = 'hanso_spotify_pending_form';
  var recentEvents = {};
  var latestCart = null;
  var initialized = false;

  function getCurrency() {
    return (
      config.currency ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD'
    );
  }

  function centsToAmount(value) {
    var amount = Number(value);

    if (!Number.isFinite(amount)) {
      return 0;
    }

    return Math.round(amount) / 100;
  }

  function createEventId(eventName) {
    var randomPart;

    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      randomPart = window.crypto.randomUUID();
    } else {
      randomPart = Math.random().toString(36).slice(2) + Date.now().toString(36);
    }

    return 'hanso-' + eventName + '-' + randomPart;
  }

  function compactPayload(payload) {
    var cleanPayload = {};

    Object.keys(payload || {}).forEach(function (key) {
      var value = payload[key];

      if (value !== undefined && value !== null && value !== '') {
        cleanPayload[key] = value;
      }
    });

    return cleanPayload;
  }

  function isMarketingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!privacy) {
      return true;
    }

    try {
      if (typeof privacy.marketingAllowed === 'function') {
        return privacy.marketingAllowed();
      }

      if (typeof privacy.marketingProcessingAllowed === 'function') {
        return privacy.marketingProcessingAllowed();
      }

      if (privacy.allowedProcessing && typeof privacy.allowedProcessing.marketing === 'boolean') {
        return privacy.allowedProcessing.marketing;
      }

      if (
        privacy.value &&
        privacy.value.allowedProcessing &&
        typeof privacy.value.allowedProcessing.marketing === 'boolean'
      ) {
        return privacy.value.allowedProcessing.marketing;
      }
    } catch (error) {
      return false;
    }

    return true;
  }

  function installPixel() {
    var scriptId = 'spdt-capture';

    window.spdt = window.spdt || function () {
      (window.spdt.q = window.spdt.q || []).push(arguments);
    };

    if (!document.getElementById(scriptId)) {
      var script = document.createElement('script');
      var firstScript = document.getElementsByTagName('script')[0];

      script.id = scriptId;
      script.async = true;
      script.src = 'https://pixel.byspotify.com/ping.min.js';

      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }

    window.spdt('conf', { key: config.pixelKey });
  }

  function track(eventName, payload, dedupeKey, dedupeWindow) {
    var key = dedupeKey || '';
    var now = Date.now();
    var windowLength = dedupeWindow || 1500;

    if (!isMarketingAllowed() || typeof window.spdt !== 'function') {
      return;
    }

    if (key && recentEvents[key] && now - recentEvents[key] < windowLength) {
      return;
    }

    if (key) {
      recentEvents[key] = now;
    }

    var cleanPayload = compactPayload(payload);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'spotify_' + eventName,
      spotify_event_name: eventName,
      spotify_event_id: cleanPayload.event_id,
      spotify_event_data: cleanPayload,
    });

    if (Object.keys(cleanPayload).length) {
      window.spdt(eventName, cleanPayload);
    } else {
      window.spdt(eventName);
    }
  }

  function trackPageAndProductViews() {
    track('view', {}, 'view:' + window.location.href, 60000);

    if (!config.product) {
      return;
    }

    track('product', {
      event_id: createEventId('product'),
      value: Number(config.product.value) || 0,
      currency: getCurrency(),
      product_id: String(config.product.productId || ''),
      product_name: config.product.productName,
      product_type: config.product.productType,
      product_vendor: config.product.productVendor,
    }, 'product:' + config.product.productId + ':' + window.location.href, 60000);
  }

  function isCartAddUrl(url) {
    var href = typeof url === 'string' ? url : url && url.url;

    return !!(href && href.indexOf('/cart/add') !== -1);
  }

  function toLineItem(item) {
    if (!item) {
      return null;
    }

    return compactPayload({
      value: centsToAmount(item.final_price || item.discounted_price || item.price),
      quantity: Number(item.quantity) || 1,
      product_id: item.product_id ? String(item.product_id) : undefined,
      product_name: item.product_title || item.title,
      product_type: item.product_type,
      product_vendor: item.vendor,
      variant_id: item.variant_id || item.id ? String(item.variant_id || item.id) : undefined,
      variant_name: item.variant_title,
    });
  }

  function refreshCart() {
    if (!window.fetch) {
      return Promise.resolve(null);
    }

    return window.fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) {
        return null;
      }

      return response.json();
    }).then(function (cart) {
      if (cart) {
        latestCart = cart;
      }

      return cart;
    }).catch(function () {
      return null;
    });
  }

  function trackAddedItems(responseData) {
    var items = responseData && Array.isArray(responseData.items)
      ? responseData.items
      : [responseData];

    items.filter(Boolean).forEach(function (item) {
      var quantity = Number(item.quantity) || 1;
      var variantId = item.variant_id || item.id || '';
      var lineValue = item.final_line_price || item.line_price;
      var value = lineValue !== undefined
        ? centsToAmount(lineValue)
        : centsToAmount((item.final_price || item.price || 0) * quantity);

      track('addtocart', {
        event_id: createEventId('addtocart'),
        value: value,
        currency: getCurrency(),
        quantity: quantity,
        product_id: item.product_id ? String(item.product_id) : undefined,
        product_name: item.product_title || item.title,
        product_type: item.product_type,
        product_vendor: item.vendor,
        variant_id: variantId ? String(variantId) : undefined,
        variant_name: item.variant_title,
      }, 'addtocart:' + variantId + ':' + quantity + ':' + value);
    });

    window.setTimeout(refreshCart, 100);
  }

  function patchFetchAddToCart() {
    if (!window.fetch || window.__hansoSpotifyFetchPatched) {
      return;
    }

    window.__hansoSpotifyFetchPatched = true;
    var originalFetch = window.fetch;

    window.fetch = function () {
      var requestUrl = arguments[0];

      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartAddUrl(requestUrl) && response && response.ok) {
          response.clone().json().then(function (data) {
            if (data && data.status !== 422) {
              trackAddedItems(data);
            }
          }).catch(function () {});
        }

        return response;
      });
    };
  }

  function patchXhrAddToCart() {
    if (!window.XMLHttpRequest || window.__hansoSpotifyXhrPatched) {
      return;
    }

    window.__hansoSpotifyXhrPatched = true;
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this._hansoSpotifyUrl = url;
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (isCartAddUrl(this._hansoSpotifyUrl)) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) {
            return;
          }

          try {
            var data = JSON.parse(this.responseText);

            if (data && data.status !== 422) {
              trackAddedItems(data);
            }
          } catch (error) {}
        });
      }

      return originalSend.apply(this, arguments);
    };
  }

  function getDiscountCode(cart) {
    if (!cart || !Array.isArray(cart.discount_applications)) {
      return '';
    }

    return cart.discount_applications.map(function (discount) {
      return discount.title;
    }).filter(Boolean).join(', ');
  }

  function trackCheckout() {
    var cart = latestCart;
    var payload = {
      event_id: createEventId('checkout'),
      currency: getCurrency(),
    };

    if (cart) {
      payload.value = centsToAmount(cart.total_price);
      payload.quantity = Number(cart.item_count) || 0;
      payload.discount_code = getDiscountCode(cart);
      payload.line_items = (cart.items || []).map(toLineItem).filter(Boolean);
    }

    track(
      'checkout',
      payload,
      'checkout:' + (cart && cart.token ? cart.token : 'unknown') + ':' + (cart && cart.item_count ? cart.item_count : 0),
      5000
    );
  }

  function isCheckoutControl(element) {
    return !!(element && element.closest && element.closest(
      'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], .checkoutBtn, [data-checkout], .shopify-payment-button__button'
    ));
  }

  function trackCheckoutStarts() {
    document.addEventListener('pointerdown', function (event) {
      if (isCheckoutControl(event.target)) {
        refreshCart();
      }
    }, true);

    document.addEventListener('click', function (event) {
      if (isCheckoutControl(event.target)) {
        trackCheckout();
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      var form = event.target;

      if (isCheckoutControl(submitter) || (form && form.querySelector('[name="checkout"]'))) {
        trackCheckout();
      }
    }, true);
  }

  function trackLead(type, category, source) {
    track('lead', {
      event_id: createEventId('lead'),
      value: 0,
      currency: getCurrency(),
      type: type,
      category: category,
    }, 'lead:' + type + ':' + source, 2000);
  }

  function trackLeadClicks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href^="tel:"], a[href^="mailto:"]');

      if (!link) {
        return;
      }

      var href = link.getAttribute('href') || '';
      var type = href.indexOf('tel:') === 0 ? 'call' : 'email';

      trackLead(type, 'contact', href);
    });
  }

  function getPendingForm() {
    try {
      return JSON.parse(window.sessionStorage.getItem(pendingFormKey) || 'null');
    } catch (error) {
      return null;
    }
  }

  function setPendingForm(data) {
    try {
      window.sessionStorage.setItem(pendingFormKey, JSON.stringify(data));
    } catch (error) {}
  }

  function clearPendingForm() {
    try {
      window.sessionStorage.removeItem(pendingFormKey);
    } catch (error) {}
  }

  function isNewsletterForm(form) {
    var tagsInput = form && form.querySelector('[name="contact[tags]"]');

    return !!(tagsInput && /newsletter/i.test(tagsInput.value || ''));
  }

  function trackFormSubmissions() {
    document.addEventListener('submit', function (event) {
      var form = event.target;

      if (!form || !form.matches('form[action*="/contact"], form[action*="contact"]')) {
        return;
      }

      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        return;
      }

      setPendingForm({
        kind: isNewsletterForm(form) ? 'signup' : 'lead',
        source: form.id || form.getAttribute('action') || 'contact_form',
        createdAt: Date.now(),
      });
    }, true);
  }

  function trackSuccessfulForm() {
    var pendingForm = getPendingForm();

    if (!pendingForm || Date.now() - Number(pendingForm.createdAt || 0) > 30 * 60 * 1000) {
      clearPendingForm();
      return;
    }

    var params = new URLSearchParams(window.location.search);
    var hasSuccessMessage = !!document.querySelector(
      '.formStatusMessage--success, .newsletter-form__message--success, .hanso-newsletter-banner__message--success'
    );

    if (params.get('contact_posted') !== 'true' && !hasSuccessMessage) {
      return;
    }

    clearPendingForm();

    if (pendingForm.kind === 'signup') {
      track('signup', {
        event_id: createEventId('signup'),
        value: 0,
        currency: getCurrency(),
        sign_up_method: 'newsletter',
      }, 'signup:' + pendingForm.source, 60000);
      return;
    }

    trackLead('form_submission', 'contact', pendingForm.source);
  }

  function initializeTracking() {
    if (initialized || !isMarketingAllowed()) {
      return;
    }

    initialized = true;
    installPixel();
    trackPageAndProductViews();
    patchFetchAddToCart();
    patchXhrAddToCart();
    trackCheckoutStarts();
    trackLeadClicks();
    trackFormSubmissions();
    trackSuccessfulForm();
    refreshCart();
  }

  window.HansoSpotify = window.HansoSpotify || {};
  window.HansoSpotify.refreshCart = refreshCart;

  document.addEventListener('visitorConsentCollected', initializeTracking);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', initializeTracking);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTracking);
  } else {
    initializeTracking();
  }
})();
